/**
 * Programs (client) – list my programs, get program.
 */
import { collection, doc, getDoc, getDocs, query, where, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION = 'programs';

function toProgram(d) {
  const data = d.data();
  return {
    id: d.id,
    coachId: data.coachId,
    clientId: data.clientId,
    title: data.title || '',
    description: data.description || '',
    weeks: data.weeks || 1,
    status: data.status || 'active',
    createdAt: data.createdAt?.toDate?.() ?? data.createdAt ?? null,
  };
}

export function programRepository({ getFirestore = () => db } = {}) {
  const firestore = getFirestore();
  const coll = () => collection(firestore, COLLECTION);

  return {
    async listByClient(clientId, limitCount = 20) {
      const q = query(
        coll(),
        where('clientId', '==', clientId),
        where('status', '==', 'active'),
        orderBy('createdAt', 'desc'),
        limit(limitCount)
      );
      const snap = await getDocs(q);
      return snap.docs.map((d) => toProgram(d));
    },
    async getById(programId) {
      const ref = doc(firestore, COLLECTION, programId);
      const snap = await getDoc(ref);
      if (!snap.exists()) return null;
      return toProgram(snap);
    },
  };
}

export const programRepo = programRepository();
